(function () {
  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function setup(root) {
    if (!root || root.getAttribute('data-cl-ready') === 'true') return;
    root.setAttribute('data-cl-ready', 'true');

    var form = qs(root, '[data-cl-form]');
    var sort = qs(root, '[data-cl-sort]');
    var aside = qs(root, '[data-cl-aside]');
    var overlay = qs(root, '[data-cl-overlay]');
    var openBtn = qs(root, '[data-cl-open]');
    var closeBtns = toArray(root.querySelectorAll('[data-cl-close]'));
    var sectionId = root.getAttribute('data-section');

    function closeDrawer() {
      if (!aside) return;
      aside.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.documentElement.classList.remove('cl-lock');
    }

    function openDrawer() {
      if (!aside) return;
      aside.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.documentElement.classList.add('cl-lock');
    }

    function buildUrl() {
      var url = new URL(root.getAttribute('data-base') || window.location.pathname, window.location.origin);
      if (form) {
        toArray(form.querySelectorAll('input, select')).forEach(function (field) {
          if (!field.name || field.disabled) return;
          if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
          if (field.value === '') return;
          url.searchParams.append(field.name, field.value);
        });
      }
      if (sort && sort.value) url.searchParams.set('sort_by', sort.value);
      return url;
    }

    function replaceFrom(html, keepDrawer) {
      var wrap = document.createElement('div');
      wrap.innerHTML = html;
      var next = wrap.querySelector('[data-cl]');
      if (!next) return;
      var wasOpen = keepDrawer && aside && aside.classList.contains('is-open');
      closeDrawer();
      root.replaceWith(next);
      setup(next);
      if (wasOpen) {
        var nextAside = next.querySelector('[data-cl-aside]');
        var nextOverlay = next.querySelector('[data-cl-overlay]');
        if (nextAside) nextAside.classList.add('is-open');
        if (nextOverlay) nextOverlay.classList.add('is-open');
        document.documentElement.classList.add('cl-lock');
      } else if (next.getBoundingClientRect().top < 0) {
        next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function load(url, push, keepDrawer) {
      if (!sectionId || !window.fetch) {
        window.location.href = url.toString();
        return;
      }

      var request = new URL(url.toString());
      request.searchParams.set('section_id', sectionId);
      root.classList.add('is-loading');

      fetch(request.toString())
        .then(function (res) {
          if (!res.ok) throw new Error('filter-failed');
          return res.text();
        })
        .then(function (html) {
          if (push) window.history.pushState({ cl: true }, '', url.toString());
          replaceFrom(html, keepDrawer);
        })
        .catch(function () {
          window.location.href = url.toString();
        });
    }

    function formatMoney(cents, format) {
      var amount = (Number(cents) / 100).toFixed(2);
      var withSep = amount.replace(/\d(?=(\d{3})+\.)/g, '$&,');
      var noDec = String(Math.round(Number(cents) / 100));
      var out = format || '${{amount}}';
      return out
        .replace(/\{\{\s*amount\s*\}\}/g, withSep)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withSep.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDec);
    }

    function toMoneyValue(cents) {
      var n = Number(cents) / 100;
      if (Math.round(n) === n) return String(n);
      return n.toFixed(2);
    }

    toArray(root.querySelectorAll('[data-cl-slider]')).forEach(function (wrap) {
      var min = wrap.querySelector('[data-cl-min]');
      var max = wrap.querySelector('[data-cl-max]');
      var minH = wrap.querySelector('[data-cl-min-hidden]');
      var maxH = wrap.querySelector('[data-cl-max-hidden]');
      var fill = wrap.querySelector('[data-cl-fill]');
      var minL = wrap.querySelector('[data-cl-min-label]');
      var maxL = wrap.querySelector('[data-cl-max-label]');
      var cap = Number(wrap.getAttribute('data-max')) || 0;
      var format = wrap.getAttribute('data-money-format') || '${{amount}}';
      if (!min || !max || !cap) return;

      function sync(apply) {
        var a = Math.min(Number(min.value), Number(max.value));
        var b = Math.max(Number(min.value), Number(max.value));
        min.value = String(a);
        max.value = String(b);
        if (minH) minH.value = a > 0 ? toMoneyValue(a) : '';
        if (maxH) maxH.value = b < cap ? toMoneyValue(b) : '';
        if (fill) {
          fill.style.left = (a / cap) * 100 + '%';
          fill.style.width = ((b - a) / cap) * 100 + '%';
        }
        if (minL) minL.textContent = formatMoney(a, format);
        if (maxL) maxL.textContent = formatMoney(b, format);
        if (apply) load(buildUrl(), true, true);
      }

      min.addEventListener('input', function () {
        sync(false);
      });
      max.addEventListener('input', function () {
        sync(false);
      });
      min.addEventListener('change', function () {
        sync(true);
      });
      max.addEventListener('change', function () {
        sync(true);
      });
      sync(false);
    });

    if (form) {
      form.addEventListener('change', function (event) {
        if (event.target && event.target.closest('[data-cl-slider]')) return;
        load(buildUrl(), true, true);
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        load(buildUrl(), true, true);
      });
    }

    if (sort) {
      sort.addEventListener('change', function () {
        load(buildUrl(), true);
      });
    }

    toArray(root.querySelectorAll('[data-cl-page] a')).forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        load(new URL(link.href, window.location.origin), true);
      });
    });

    toArray(root.querySelectorAll('[data-cl-remove]')).forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        load(new URL(link.href, window.location.origin), true);
      });
    });

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closeDrawer);
    });
    if (overlay) overlay.addEventListener('click', closeDrawer);

    toArray(root.querySelectorAll('[data-cl-cart]')).forEach(function (el) {
      el.addEventListener('submit', function (event) {
        var formEl = event.currentTarget;
        var button = formEl.querySelector('[data-cl-add]');
        var label = formEl.querySelector('[data-cl-add-label]');
        if (!button || !window.fetch) return;

        event.preventDefault();
        if (button.classList.contains('is-busy')) return;

        var original = label ? label.textContent : '';
        button.classList.add('is-busy');
        button.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: Number(formEl.querySelector('input[name="id"]').value),
                quantity: 1
              }
            ]
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add-failed');
            return res.json();
          })
          .then(function () {
            button.classList.remove('is-busy');
            button.classList.add('is-done');
            button.disabled = false;
            if (label) label.textContent = button.getAttribute('data-added') || 'Added';
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            setTimeout(function () {
              button.classList.remove('is-done');
              if (label) label.textContent = original;
            }, 2200);
          })
          .catch(function () {
            button.classList.remove('is-busy');
            button.disabled = false;
            formEl.submit();
          });
      });
    });
  }

  function boot() {
    toArray(document.querySelectorAll('[data-cl]')).forEach(setup);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    toArray(document.querySelectorAll('[data-cl-aside].is-open')).forEach(function (el) {
      el.classList.remove('is-open');
    });
    toArray(document.querySelectorAll('[data-cl-overlay].is-open')).forEach(function (el) {
      el.classList.remove('is-open');
    });
    document.documentElement.classList.remove('cl-lock');
  });

  window.addEventListener('popstate', function () {
    window.location.reload();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
